import { useState } from "react"

// COMPONENTS
import { Divider, Input } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../Icon"

import "./styles.less"

const { Search } = Input

export const SearchComponent = ({
  handleSearch,
  button,
  disabled,
  onFocusCallback,
  value,
  onKeyUp,
  wrapperStyle,
  gps = false,
  ...props
}) => {
  const { t } = useTranslation()
  const [focusedSearch, setFocusedSearch] = useState(false)
  const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)
  return (
    <div className="search" style={wrapperStyle && wrapperStyle}>
      <div
        className={cls("search_wrapper", {
          "disabled-transition": isDisabledTransition
        })}
      >
        <Search
          placeholder={props?.placeholder ? props?.placeholder : t("common.search_products")}
          className="search-input"
          onFocus={() => {
            setFocusedSearch(true)
            onFocusCallback && onFocusCallback()
          }}
          onBlur={() => setFocusedSearch(false)}
          onChange={(e) => {
            e.persist()
            handleSearch(e)
          }}
          onKeyUp={(e) => {
            if (onKeyUp) {
              onKeyUp(e)
              if (e.keyCode === 13) setFocusedSearch(false)
            }
          }}
          defaultValue={value && value}
          {...(value ? { value: value } : null)}
          prefix={
            <>
              <Icon
                type={gps ? "gps" : "search"}
                role="icon"
                color={focusedSearch ? "#225AEA" : "#707BA0"}
              />
              <Divider type="vertical" className="search-divider" />
            </>
          }
          disabled={disabled}
        />
        <div className="search_button">{button}</div>
      </div>
    </div>
  )
}

SearchComponent.defaultProps = {}

SearchComponent.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  button: PropTypes.object
}

export default SearchComponent
